import React from "react";
import { number, bool } from "prop-types";
import { Box, Card, Typography } from "@mui/material";
import { videoType } from "../../constants/proptypes";
import PlatformChips from "../PlatformChips";

const VideoPlayer = ({ isFeatured, video, width, height }) => {
  const { id, title, tags = [], description = "" } = video;
  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        backgroundColor: "transparent",
        paddingBottom: theme.spacing(4),
        overflow: "visible",
        "& > iframe": {
          backgroundColor: "#000",
          margin: theme.spacing(0),
          padding: theme.spacing(0),
        },
        "& > .video-title": {
          display: "block",
          padding: theme.spacing(0),
          paddingBottom: theme.spacing(0.5),
          textAlign: "left",
          "&.featured": {
            fontWeight: "normal",
          },
          "&.related": {
            fontWeight: "normal",
          },
        },
      })}
    >
      {isFeatured && (
        <Box sx={{ mb: 2 }}>
          <Box sx={{ alignItems: "center", display: "flex", mb: 1 }}>
            <Typography
              component="h1"
              variant="h3"
              className="video-title featured"
              sx={(theme) => ({ margin: 0, marginRight: theme.spacing(2) })}
            >
              {title}
            </Typography>
            {tags.length > 0 && <PlatformChips chips={tags} />}
          </Box>
          {description && <Typography>{description}</Typography>}
        </Box>
      )}
      <Box
        sx={{
          position: "relative",
          paddingBottom: "56.25%",
          height: 0,
          "& iframe": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          },
        }}
      >
        <iframe
          title={title}
          id={`ytplayer-${id}`}
          width={width}
          height={height}
          src={`https://www.youtube.com/embed/${id}?hd=1&autohide=0`}
          frameBorder="0"
          allowFullScreen
        />
      </Box>
      {!isFeatured && (
        <Typography
          component="h4"
          className="video-title related"
          sx={(theme) => ({ margin: 0, marginTop: theme.spacing(1) })}
        >
          {title}
        </Typography>
      )}
    </Card>
  );
};

VideoPlayer.defaultProps = {
  isFeatured: false,
};

VideoPlayer.propTypes = {
  isFeatured: bool,
  width: number,
  height: number,
  video: videoType.isRequired,
};

export default VideoPlayer;
